import { atom } from "recoil";

const DestinationCityAtom = atom<string | null>({
    default: null,
    key: 'destinationCityAtomKey'
})

export default DestinationCityAtom;